import { DeepReadonly } from "ts-essentials"
import { Button } from "@mui/material"
import useMountEffect from "hooks/mount-effect"

export default function EmptyDashboard({ openUnifiedSearch }: DeepReadonly<EmptyDashboardProps>) {
  useMountEffect(() => {
    openUnifiedSearch()
  })

  return <div className="modules_dashboard-root">
    <div className="dashboard-empty">
      <h4>Please select an instrument first</h4>
      <Button className="dashboard-empty-button" variant="contained" color="primary" onClick={openUnifiedSearch}>Search</Button>
    </div>
  </div>
}

interface EmptyDashboardProps {
  openUnifiedSearch: () => void
}
